import React from 'react'
import type { PostCategory } from '../../api/postCategories'
import CategorySelect from '../../components/ui/CategorySelect'

type Props = {
  title: string
  subtitle: string
  onChangeTitle: (v: string) => void
  onChangeSubtitle: (v: string) => void
  hideTitleSubtitle?: boolean
  format: 'micro' | 'zine' | 'book' | 'event' | 'job'
  onChangeFormat: (v: 'micro' | 'zine' | 'book' | 'event' | 'job') => void
  category: string
  onChangeCategory: (slug: string) => void
  categories: PostCategory[]
}

export default function TitleFields({
  title,
  subtitle,
  onChangeTitle,
  onChangeSubtitle,
  hideTitleSubtitle,
  format,
  onChangeFormat,
  category,
  onChangeCategory,
  categories,
}: Props) {
  return (
    <>
      {!hideTitleSubtitle ? (
        <>
          <input
            value={title}
            onChange={(e) => onChangeTitle(e.target.value)}
            placeholder="Title"
            className="w-full rounded-xl bg-white/5 border border-white/10 px-4 py-3 text-lg font-semibold outline-none focus:ring-2 focus:ring-brand"
          />
          <input
            value={subtitle}
            onChange={(e) => onChangeSubtitle(e.target.value)}
            placeholder="Subtitle (optional)"
            className="w-full rounded-xl bg-white/5 border border-white/10 px-4 py-2 outline-none focus:ring-2 focus:ring-brand"
          />
        </>
      ) : null}

      <div>
        <div className="mb-2 text-sm text-white/70">Metadata</div>
        <div className="flex flex-wrap gap-3">
          <div className="min-w-[240px] flex-1">
            <div className="mb-1 text-xs text-white/60">Format (required)</div>
            <div className="inline-flex flex-wrap gap-2">
              {(['micro', 'zine', 'book', 'event', 'job'] as const).map((k) => (
                <button
                  key={k}
                  type="button"
                  aria-pressed={format === k}
                  onClick={() => onChangeFormat(k)}
                  className={`px-3 py-1.5 rounded-full border text-xs ${
                    format === k
                      ? 'bg-brand/20 border-brand/40 text-brand'
                      : 'bg-white/5 border-white/10 text-white/85 hover:bg-white/10'
                  }`}
                >
                  {k === 'micro' ? 'Micro' : k === 'zine' ? 'Zine' : k === 'book' ? 'Book' : k === 'event' ? 'Event' : 'Job'}
                </button>
              ))}
            </div>
          </div>

          <div className="min-w-[240px] flex-1">
            <div className="mb-1 text-xs text-white/60">Category (required)</div>
            <CategorySelect value={category} onChange={onChangeCategory} options={categories} required placeholder="Select category" />
          </div>
        </div>
        {!category ? <div className="mt-2 text-xs text-red-300">Select a category to publish.</div> : null}
      </div>
    </>
  )
}
